import { ReactComponent as Spinner } from 'theme/svg/spinner.svg';

import styles from './ButtonSpinner.module.scss';

function ButtonSpinner(): JSX.Element {
  return <Spinner className={styles.spinner} />;
}

export default ButtonSpinner;
